var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scroll-button elektra-bg-red block rounded-full flex justify-center items-center cursor-pointer"},[_c('font-awesome-icon',{staticClass:"text-white text-xl",attrs:{"icon":"fa-solid fa-arrow-down"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }